function R(h) {
  return h.replace(/^(\d)/, "\\3$1 ").replace(/([#{}.:;?%&,@+*~'"!^$[\]()=>|/])/g, "\\$1");
}
function W(h) {
  if (/^(webkit|moz|ms|o)[A-Z]/.test(h)) {
    const s = h.match(/^(webkit|moz|ms|o)/);
    if (s) {
      const e = s[0];
      return `-${e}${h.slice(e.length).replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`)}`;
    }
  }
  return h.replace(/[A-Z]/g, (s) => `-${s.toLowerCase()}`);
}
function b(h, s, e, t, r, n) {
  return `${h ? `${h}:` : ""}${s}${e ? "-" : ""}${e}${t}${r ? `/${r}${n}` : ""}`;
}
function P(h) {
  return h.replace(/[.*+?^${}()|[\]\\/\\-]/g, "\\$&");
}
function z(h) {
  if (!h) return [];
  const s = /* @__PURE__ */ new Set();
  return Object.entries(h).forEach(([e, t]) => {
    t && typeof t == "object" && Object.keys(t).forEach((r) => {
      s.add(r);
    });
  }), Array.from(s);
}
function I({
  safelist: h = [],
  property: s = {},
  classes: e = {}
} = {}) {
  const t = e, r = Object.keys(s);
  if (!t)
    return [...r, ...h].sort((a, o) => o.length - a.length);
  const n = [...z(t)];
  return [...r, ...n, ...h].sort((a, o) => o.length - a.length);
}
function V({
  inputPrefixChars: h = [],
  safelist: s = [],
  property: e = {},
  classes: t = {}
} = {}) {
  let r = I({ safelist: s, property: e, classes: t }).map(
    P
  );
  r.length > 0 && (r = r.join("|") + "|");
  const n = "\\[[^\\]]+\\]", a = "\\([^()]*(?:\\([^()]*\\)[^()]*)*\\)", o = "\\{[^{}]*(?:\\{[^{}]*\\}[^{}]*)*\\}", u = `[${["a-zA-Z0-9_\\-", ...h].join("")}]`, i = (
    // Simple prefix (hover, md, focus, etc.)
    u + "+|" + // value-like prefix (nth-(4), max-[445px], etc.)
    u + "+(?:-(?:" + n + "|" + a + "|" + o + "))|" + // added support for custom secondValue for prefix
    u + "+(?:-(?:" + n + "|" + a + "|" + o + "))?(?:\\/[a-zA-Z0-9_\\-]+)|" + // Direct bracket, parenthesis, or brace content
    n + "|" + a + "|" + o
  ), d = `(${r}\\[[^\\]]+\\])`, l = "(?:-)", c = "(-?(?:\\d+(?:\\.\\d+)?)|(?:[a-zA-Z0-9_]+(?:-[a-zA-Z0-9_]+)*(?:-[a-zA-Z0-9_]+)*)|(?:#[0-9a-fA-F]+)|" + // Hex colors
  n + "|" + // Bracket content
  o + "|" + // Curly brace content
  a + "|(?:\\$[^\\s\\/]+))", m = "([a-zA-Z%]*)", f = "(?:\\/(-?(?:\\d+(?:\\.\\d+)?)|(?:[a-zA-Z0-9_]+(?:-[a-zA-Z0-9_]+)*(?:-[a-zA-Z0-9_]+)*)|(?:#[0-9a-fA-F]+)|" + n + "|" + o + "|" + a + "|(?:\\$[^\\s\\/]+))([a-zA-Z%]*))?";
  return {
    prefix: i,
    type: d,
    separator: l,
    value: c,
    unit: m,
    secondValuePattern: f,
    all: "^(?:(" + i + "):)?" + d + l + c + m + f + "$"
  };
}
class N {
  constructor({ property: s = {}, values: e = {}, classes: t = {}, prefixChars: r = [] } = {}) {
    this.property = s, this.values = e, this.classes = t, this.prefixChars = r.map(P);
  }
  parse(s, e) {
    const t = V({
      safelist: e,
      property: this.property,
      classes: this.classes,
      inputPrefixChars: this.prefixChars
    }), r = s.match(new RegExp(t.all));
    if (r) {
      const [, a, o, u, i, d, l] = r;
      return [a, o, u, i || "", d, l];
    }
    const n = s.match(
      new RegExp(`^(?:(${t.prefix}):)?${t.type}$`)
    );
    return n ? [n[1], n[2], "", "", void 0, void 0] : null;
  }
  // unique value parser
  processValue(s, e, t) {
    if (!s) return "";
    const r = (n) => n.replace(/\{([^}]+)\}/g, (a, o) => {
      const u = this.values, i = u !== null ? typeof u[t] == "object" ? u[t][o] : u[o] : void 0;
      return typeof i == "string" ? i : a;
    });
    if (typeof this.values == "object" && this.values !== null && (this.values[t] && typeof this.values[t] == "object" && this.values[t][s] || this.values[s]))
      return typeof this.values[t] == "object" && this.values[t] !== null ? this.values[t][s] : this.values[s];
    if (s.startsWith("$"))
      return `var(--${s.slice(1)})`;
    if (s.startsWith("[") && s.endsWith("]") || s.startsWith("(") && s.endsWith(")")) {
      const n = s.slice(1, -1).replace(/\\\_/g, "m0x13c55").replace(/\_/g, " ").replace(/m0x13c55/g, "_");
      return n.includes("{") ? r(n) : n.startsWith("--") ? `var(${n})` : n;
    }
    return s + (e || "");
  }
  processShorthand(s = "", e = "", t = "", r, n = "", a = "", o = "", u) {
    const i = this.property[s];
    if (typeof i == "object" && !Array.isArray(i) && !("property" in i))
      return null;
    const d = /^(?:\(|\[)([^:]+):(.+)(?:\)|\])$/;
    let l = null, c = e || "";
    const m = c.match(d);
    if (m && (l = m[1].trim(), c = m[2].trim()), (typeof i == "string" && !i.includes(":") || Array.isArray(i)) && (!e || e.includes(l + ":") || n))
      return null;
    let f;
    e.includes(l + ":") ? f = e.startsWith("(") ? `(${c})` : `[${c}]` : f = e;
    const g = this.processValue(f, t, s), y = this.processValue(n, a, s);
    if (s.startsWith("[") && s.endsWith("]")) {
      if (!e || n) return null;
      const p = s.slice(1, -1).split(",").map(
        (v) => v.trim().startsWith("--") ? String(v.trim()) : W(String(v.trim()))
      );
      return {
        className: b(r, s, e, t),
        cssRules: p.length === 1 ? p[0] : p,
        value: g,
        prefix: r
      };
    }
    if (i) {
      if (typeof i == "object" && "property" in i) {
        const v = i.group && this.values[i.group][g] ? this.values[i.group][g] : t ? e : g, $ = (
          // handle `properties.property` function
          typeof i.property == "function" ? i.property({
            value: e.startsWith("[") ? g : v,
            unit: e.startsWith("[") ? "" : t,
            secondValue: e.startsWith("[") ? "" : a ? n : y,
            secondUnit: e.startsWith("[") ? "" : a,
            key: l,
            raw: u
          }) : (
            // defaulting to string property
            // e.g. { property: { p: { property: 'padding', value: '{0} {1}' } }
            // the `p` is the type or the shorthand for `padding` property -
            // and has support for second value
            i.property
          )
        );
        if ($ && typeof $ == "object" && !Array.isArray($) && "cssRules" in $) {
          const { className: x, cssRules: w, value: j, prefix: Z } = $;
          return {
            className: x || o,
            cssRules: w,
            value: j,
            prefix: Z || r,
            isCustom: !!x
          };
        }
        const A = i.value || "{0}";
        let C;
        if (typeof A == "function")
          C = A({
            value: v,
            unit: t,
            secondValue: a ? n : y,
            secondUnit: a,
            key: l,
            raw: u
          });
        else if (typeof A == "string") {
          const x = i.group || s, w = this.processValue(f, t, x);
          this.values[x] && typeof this.values[x] == "object" && this.values[x][f] ? C = this.values[x][f] : A.includes("{") ? C = this.parseValuePattern(
            x,
            A,
            w,
            "",
            y,
            ""
          ) : typeof A == "string" && !A.includes("{") ? C = A : C = g;
        } else if (Array.isArray(A)) {
          if (!A.includes(e + t) || n) return null;
          C = e + t;
        } else C = null;
        return (typeof i.property == "string" || Array.isArray(i.property)) && typeof A == "string" && (e.includes(l + ":") || !A.includes("{1") && n) || // check if the property is string or array of properties
        // but the value is null
        (typeof i.property == "string" || Array.isArray(i.property)) && A === null || // check if the type is a direct rules but has `value` defined
        typeof i.property == "string" && i.property.includes(":") && e || (typeof i.property == "string" || Array.isArray(i.property)) && typeof i.value == "string" && !i.value.includes("{") && e ? null : {
          className: b(r, s, e, t, n, a),
          cssRules: (
            // if not property, or when `properties.property` as function return null
            $ ? Array.isArray($) ? $ : (
              // is direct CSS rules
              typeof $ == "string" && ($.includes(":") || $.includes("value:")) && $.includes("value:") ? $.slice(6) : (
                // basic string property
                W(String($))
              )
            ) : null
          ),
          value: A === null || $ === null || $.includes(":") || $.includes("value:") ? null : e.startsWith("[") ? g : C,
          prefix: r
        };
      }
      const p = (
        // handle `properties` as function
        // e.g. m: ({ value, unit }) => `margin: ${value}${unit || 'px'}`
        // m-4 => margin: 4px
        // m-4rem => margin: 4rem
        typeof i == "function" ? i({
          value: e.startsWith("[") ? g : t ? e : g,
          unit: e.startsWith("[") ? "" : t,
          secondValue: e.startsWith("[") ? "" : a ? n : y,
          secondUnit: e.startsWith("[") ? "" : a,
          key: l,
          raw: u
        }) : (
          // e.g. { property: { bg: 'background' } }
          // the `bg` is the type or the shorthand for `background` property
          i
        )
      );
      if (p && typeof p == "object" && !Array.isArray(p) && "cssRules" in p) {
        const { className: v, cssRules: $, value: A, prefix: C } = p;
        return {
          className: v || o,
          cssRules: $,
          value: A,
          prefix: C || r,
          isCustom: !!v
        };
      }
      return {
        className: b(r, s, e, t, n, a),
        cssRules: p ? Array.isArray(i) ? p : typeof p == "string" && (p.includes(":") || p.startsWith("value:")) && p.startsWith("value:") ? p.slice(6) : W(String(p)) : null,
        value: typeof p == "string" && p.includes(":") ? null : g,
        prefix: r
      };
    }
    return null;
  }
  parseValuePattern(s, e, t, r, n, a) {
    if (!e.includes("{0}") && !e.includes("{1") && !e.includes("||"))
      return e;
    const [o, u] = e.split("||").map((l) => l.trim()), i = this.processValue(t, r, s), d = this.processValue(n, a, s);
    if (e.includes("{0}") && e.includes("{1") || e.includes("{1")) {
      let l = o;
      if (t && (l = l.replace(/\{0\}/g, i)), e.includes("{1")) {
        e.includes("{1}") && (n ? l = n.startsWith("[") ? d : l.replace(/\{1\}/g, d) : l = u || o);
        const c = /\{1([^}]*)\}/g;
        let m;
        for (; (m = c.exec(l)) !== null; ) {
          const f = m[0], g = m[1].trim();
          let y = d;
          !y && g.includes("|") ? y = g.split("|")[1].trim() : y || (y = ""), l = t.startsWith("[") ? i : l.replace(f, y);
        }
      }
      return t ? l : u || o;
    } else
      return t ? t.startsWith("[") ? i : o.replace(/\{0\}/g, i) : u || o;
  }
  getParentClass(s) {
    return Object.keys(this.classes).filter(
      (e) => Object.prototype.hasOwnProperty.call(
        this.classes[e],
        s
      )
    );
  }
  processCustomClass(s, e = "", t = "", r = "", n = "", a = "") {
    if (!s) return null;
    const o = this.getParentClass(s), u = e && s.endsWith(`-${e}${t}`);
    if (o.length > 0) {
      const i = o.map((d) => {
        const l = this.classes[d];
        if (!l || e && !u && l[s] && !l[s].includes("{0}") && !l[s].includes("|"))
          return null;
        const c = this.parseValuePattern(
          s,
          l[s] || "",
          e,
          t,
          n,
          a
        );
        return `${W(String(d))}: ${c}`;
      }).filter(Boolean).join("; ");
      return {
        className: u ? s : b(r, s, e, t, n, a),
        cssRules: i,
        value: null,
        prefix: r
      };
    }
    return null;
  }
  process(s) {
    try {
      const e = Array.isArray(s) ? s : s.split(/\s+/), t = [];
      for (const r of e)
        try {
          if (!r) continue;
          const n = this.parse(r);
          if (!n) continue;
          const [a, o, u, i, d, l] = n;
          if (!o) continue;
          const c = [...n, b(a, o, u, i, d, l)], m = this.getParentClass(`${o}-${u}`).length > 0 ? `${o}-${u}` : o;
          try {
            const f = this.processCustomClass(
              m,
              u,
              i,
              a,
              d,
              l
            );
            if (f) {
              const { className: g, cssRules: y, prefix: p } = f;
              if (!y || y === "null") continue;
              t.push({
                className: R(g),
                cssRules: y,
                value: null,
                prefix: p,
                raw: c
              });
              continue;
            }
          } catch (f) {
            console.warn(`Error processing custom class "${r}":`, f);
          }
          try {
            const f = this.processShorthand(
              o,
              u,
              i,
              a,
              d,
              l,
              r,
              c
            );
            if (f) {
              const { className: g, cssRules: y, value: p, prefix: v, isCustom: $ } = f;
              if (!y || y === "null") continue;
              t.push({
                className: $ ? g : R(g),
                cssRules: y,
                value: p,
                prefix: v,
                raw: c
              });
            }
          } catch (f) {
            console.warn(`Error processing shorthand "${r}":`, f);
          }
        } catch (n) {
          console.warn(`Failed to process class \`${r}\`:`, n);
        }
      return t;
    } catch (e) {
      return console.error("Critical error in process method:", e), [];
    }
  }
}
/*!
 * @nousantx/someutils v0.7.1 | MIT License
 *
 * Copyright (c) 2024-present NOuSantx <nousantx@gmail.com>
 *
 * Built Date: Mon May 05 2025 06:00:21 GMT+0700 (Western Indonesia Time)
 */
function k(...h) {
  return h.reduce((s, e) => (Object.keys(e).forEach((t) => {
    const r = t;
    typeof e[r] == "object" && e[r] !== null && !Array.isArray(e[r]) ? s[r] = k(s[r] || {}, e[r]) : s[r] = e[r];
  }), s), {});
}
function S(h) {
  const s = h;
  if (/^(webkit|moz|ms|o)[A-Z]/.test(s)) {
    const e = s.match(/^(webkit|moz|ms|o)/);
    if (e) {
      const t = e[0];
      return `-${t}${s.slice(t.length).replace(/[A-Z]/g, (r) => `-${r.toLowerCase()}`)}`;
    }
  }
  return s.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
function E(h) {
  return h.replace(/^(\d)/, "\\3$1 ").replace(/([#{}.:;?%&,@+*~'"!^$[\]()=>|/])/g, "\\$1");
}
class _ {
  constructor({
    property: s = {},
    values: e = {},
    classes: t = {},
    aliases: r = {},
    breakpoints: n = {},
    variants: a = {},
    tenoxui: o = N,
    tenoxuiOptions: u = {},
    reservedVariantChars: i = [],
    prefixLoaderOptions: d = {}
  } = {}) {
    this.engine = o, this.variants = a, this.property = s, this.values = e, this.classes = t, this.aliases = r, this.breakpoints = n, this.tuiConfig = k(
      {
        property: this.property,
        values: this.values,
        classes: this.classes,
        prefixChars: i
      },
      u
    ), this.main = new this.engine(this.tuiConfig), this.prefixLoader = new this.engine(
      k(
        {
          property: this.variants,
          values: this.breakpoints,
          prefixChars: i
        },
        d
      )
    );
  }
  createEngine(s = {}) {
    return new this.engine(s);
  }
  getConfig() {
    return this.tuiConfig;
  }
  getBreakpointQuery(s) {
    if (s.startsWith("min-")) {
      const e = s.substring(4);
      if (this.breakpoints[e])
        return `@media (width >= ${this.breakpoints[e]})`;
    } else if (s.startsWith("max-")) {
      const e = s.substring(4);
      if (this.breakpoints[e])
        return `@media (width < ${this.breakpoints[e]})`;
    } else if (this.breakpoints[s])
      return `@media (width >= ${this.breakpoints[s]})`;
    return null;
  }
  processCustomPrefix(s) {
    try {
      const e = this.prefixLoader.process(s);
      if ((e == null ? void 0 : e.length) > 0)
        return e[0].cssRules;
    } catch (e) {
      console.error(`Failed to process prefix ${s}:`, e);
    }
    return null;
  }
  generatePrefix(s) {
    if (this.prefixLoader.parse(s)) {
      const t = this.processCustomPrefix(s);
      if (t && typeof t == "string")
        return t.startsWith("value:") ? t.substring(6) : t;
    }
    if (s.startsWith("[") && s.endsWith("]") || s.startsWith("(") && s.endsWith(")"))
      return this.prefixLoader.processValue(s, "", "");
    const e = this.getBreakpointQuery(s);
    return e || null;
  }
  isImportantClass(s, e, t) {
    const r = `${s}:${e}`;
    return t[r] || !1;
  }
  parseImportantClassNames(s) {
    const e = [], t = {}, r = Array.isArray(s) ? s : s.split(/\s+/).filter(Boolean), n = [];
    return r.forEach((a, o) => {
      if (a.startsWith("!")) {
        const u = a.slice(1);
        n.push({
          name: u,
          isImportant: !0,
          originalIndex: o
        });
      } else
        n.push({
          name: a,
          isImportant: !1,
          originalIndex: o
        });
    }), n.forEach(({ name: a, isImportant: o, originalIndex: u }) => {
      e.push(a);
      const i = `${a}:${u}`;
      t[i] = o;
    }), { parsedClassNames: e, importantMap: t };
  }
  processAlias(s, e, t, r = !1) {
    if (!s || !this.aliases[s]) return null;
    let n = R(e ? `${e}:${s}` : s);
    const a = [], o = [], { parsedClassNames: u, importantMap: i } = this.parseImportantClassNames(
      this.aliases[s]
    );
    this.main.process(u).map((l, c) => {
      const { cssRules: m, value: f, prefix: g, raw: y } = l, p = this.isImportantClass(y[6], c, i), v = g ? { prefix: g, data: this.generatePrefix(g) } : null;
      if (!v)
        a.push({
          cssRules: m,
          value: f,
          isImportant: p
        });
      else {
        if (v && v.prefix === e || !v.data) return;
        o.push({
          className: v.data.includes("&") ? v.data.replace("&", n) : n,
          cssRules: m,
          value: f,
          isImportant: p,
          variant: v.data
        });
      }
    });
    const d = Object.values(
      o.reduce(
        (l, c) => {
          const m = `${c.className}|${c.variant}`;
          return l[m] || (l[m] = {
            className: c.className,
            rules: [],
            variant: c.variant
          }), l[m].rules.push({
            cssRules: c.cssRules,
            value: c.value,
            isImportant: c.isImportant
          }), l;
        },
        {}
      )
    );
    return {
      className: (r ? "\\!" : "") + n,
      rules: a,
      isImportant: r,
      prefix: e ? { name: e, data: this.generatePrefix(e) } : null,
      variants: d.length > 0 ? d : null,
      raw: t || []
    };
  }
  process(s) {
    const e = s ? Array.isArray(s) ? s : s.split(/\s+/).filter(Boolean) : [], { parsedClassNames: t, importantMap: r } = this.parseImportantClassNames(e);
    if (!t || t.length === 0) return null;
    const n = [];
    return t.forEach((a, o) => {
      const u = this.main.parse(a, Object.keys(this.aliases)), i = this.isImportantClass(a, o, r), d = u && u[0] ? a.slice(u[0].length + 1) : a;
      if (u && u[1] && this.aliases[d]) {
        const [l] = u;
        if (l && !this.generatePrefix(l)) return null;
        const c = this.processAlias(d, l, u, i);
        c && n.push(c);
      } else
        this.main.process(a).forEach((c) => {
          const { className: m, cssRules: f, value: g, prefix: y, raw: p } = c;
          y && !this.generatePrefix(y) || n.push({
            className: (i ? "\\!" : "") + m,
            isImportant: i,
            cssRules: f,
            value: g,
            variants: y ? { name: y, data: this.generatePrefix(y) } : null,
            raw: p || null
          });
        });
    }), n;
  }
}
export {
  N as Moxie,
  _ as TenoxUI,
  b as constructRaw,
  _ as default,
  R as escapeCSSSelector,
  E as escapeSelector,
  V as regexp,
  S as toKebabCase
};
